import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const PublicStatusInput = ({name, label, onChange, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: 'journal_post_public_status_1',
    },
    {
      value: 2,
      label: 'journal_post_public_status_2',
    },
    {
      value: 3,
      label: 'journal_post_public_status_3',
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={[
            {required: true, message: t('feedback_validation_required')},
          ]}
          {...props}
        >
          <Select disabled={disabled} onChange={onChange}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default PublicStatusInput;
